// extracted by mini-css-extract-plugin
export default {"text":"GetPIN_text__VzkVC","pin":"GetPIN_pin__bWphq","button":"GetPIN_button__Gy9Oe"};